import { Helmet } from 'react-helmet-async';
import { siteImages } from '../mock';
import { mediaUrl } from '../lib/api';

const SITE = 'MASHMARI';

export default function Seo({ title, description, image, path }) {
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Transforming Learning. Connecting Communities. Building Digital Trust.`;
  const img = image
    ? (/^https?:\/\//i.test(image)
      ? image
      : (image.startsWith('/api/') ? mediaUrl(image) : `${typeof window !== 'undefined' ? window.location.origin : ''}${image}`))
    : mediaUrl(siteImages.homeBand);
  const url = typeof window !== 'undefined' ? `${window.location.origin}${path || window.location.pathname}` : '';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
